import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, Autoplay } from "swiper/modules";
import itemsData from "../config/itemsData";
// import { NavLink } from "react-router-dom";
import CachedImage from "./CachedImage";
import ImgSvg from "./ImgSvg";
import { whatsappNumber, whatsappMessage } from "../config/constants";

function CarouselSection() {
  const allProducts = itemsData;

  // Early return if no products
  if (!allProducts || allProducts.length === 0) {
    return (
      <section className="w-full container mx-auto px-4 py-1 md:h-[84vh] sm:h-[80vh] h-[63.5vh]" aria-label="Carousel Section">
        <div className="rounded-lg shadow-lg h-full bg-gray-200 flex items-center justify-center">
          <div className="text-center">
            <ImgSvg className="w-20 h-20 text-gray-500 mx-auto mb-4" />
            <p className="text-gray-600">No products available</p>
          </div>
        </div>
      </section>
    );
  }

  const handleWhatsAppOrder = (product) => {
    const message = whatsappMessage(product);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="w-full container mx-auto px-4 py-1 md:h-[84vh] sm:h-[80vh] h-[63.5vh]" aria-label="Carousel Section">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        autoplay={{ delay: 3000 }}
        pagination={{ clickable: true }}
        navigation
        loop
        className="rounded-lg shadow-lg h-full"
        style={{ 
          backgroundColor: "#f3f4f6", 
          backgroundImage: allProducts[0]?.banner_image ? `url(${allProducts[0].banner_image})` : 'none', 
          backgroundSize: "cover", 
          backgroundPosition: "center" 
        }}
      >
        <div className="relative z-[-1] w-full h-full flex items-center justify-center">
          <ImgSvg className="w-40 h-40 text-gray-500 " />
        </div>
        {allProducts.map((product) => (
          <SwiperSlide key={product.product_id}>
            <div className="relative h-full">
              {/* background banner */}
              {/* <CachedImage
                src={product.banner_image}
                alt="banner"
                className="w-full h-full object-cover rounded-lg"
              /> */}

              {/* overlay content */}
              <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center flex-col md:flex-row gap-4">
                {/* left product image */}
                <div className="w-[30%] md:h-full sm:h-[35%] h-[43%] flex justify-center items-center aspect-">
                  <CachedImage
                    src={product.product_feature_img}
                    alt={product.title}
                    className="w-auto h-auto object-cover rounded-lg block mx-2 md:scale-[0.7] sm:scale-[0.5] 2xl:scale-[0.8] scale-125 mb-4"
                    loadingComponent={
                        <div className="text-gray-500 text-sm">
                          <ImgSvg className="w-20 h-20" />
                        </div>
                    }
                  />
                </div>

                {/* right content */}
                <div className="text-center text-white max-w-2xl px-6 2xl:space-y-3">
                  <h1 className="md:text-4xl lg:text-5xl text-2xl font-bold md:mb-2 mb-[1px] 2xl:text-6xl">
                    {product.title}
                  </h1>
                  <div className="flex justify-center items-center">
                    <p className="md:text-xl text-xs w-full md:w-2/3 md:mb-4 mb-2 2xl:text-2xl">
                      {product.description}
                    </p>
                  </div>
                  <div className="flex items-center justify-center gap-4 md:mb-4 mb-3">
                    <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs md:text-sm 2xl:text-lg font-bold">
                      {product.discount_percentage}% OFF
                    </span>
                  </div>
                  <div
                    className="w-full flex justify-center items-center mb-2"
                    onClick={() => handleWhatsAppOrder(product)}
                  >
                    <button className="bg-white hover:bg-primary hover:text-white text-green-500 px-8 py-3 rounded-lg font-semibold transition-colors duration-300 text-xs md:text-sm 2xl:text-xl flex items-center justify-center gap-2">
                    <i className="fa-brands fa-whatsapp text-xl"></i> Message Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* custom pagination & nav styles */}
      <style>{`
        .swiper-pagination-bullet {
          background: white !important;
          opacity: 0.6;
          width: 10px;
          height: 10px;
        }
        .swiper-pagination-bullet-active {
          background: white !important; /* red-500 */
          opacity: 1;
        }
        .swiper-button-prev,
        .swiper-button-next {
          color: white !important;
          width: 35px;
          height: 35px;
          background-color: rgba(243, 244, 246, 0.3); /* light transparent gray */
          back-drop-filter: blur(10px);
          border-radius: 50%;
          padding: 10px;
          transition: all 0.3s ease;
          margin: 0 10px;
        }
        .swiper-button-prev:hover,
        .swiper-button-next:hover {
          background-color: rgba(243, 244, 246, 0.5);
          transition: all 0.3s ease;
        }
        .swiper-button-prev::after,
        .swiper-button-next::after {
          font-size: 20px;
          font-weight: bold;
          color: white;
        }
      `}</style>
    </section>
  );
}

export default CarouselSection;
